module.exports = __webpack_public_path__ + "static/img/footer_12.d8cbec0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/footer_12.jpg
// module id = 6yLO
// module chunks = 7